import {Vulnerabilities} from '../../schema-types/Vulnerabilities';

export type longTermVulTypes = keyof Pick<
  Vulnerabilities,
  | 'ageVulnerability'
  | 'healthVulnerability'
  | 'hearingVulnerability'
  | 'languageVulnerability'
  | 'learningVulnerability'
  | 'visionVulnerability'
  | 'mentalHealthVulnerability'
  | 'mentalCapacityVulnerability'
  | 'genderReassignment'
  | 'otherVulnerability'
>;

export const longTermVul: longTermVulTypes[] = [
  'ageVulnerability',
  'healthVulnerability',
  'hearingVulnerability',
  'languageVulnerability',
  'learningVulnerability',
  'visionVulnerability',
  'mentalHealthVulnerability',
  'mentalCapacityVulnerability',
  'genderReassignment',
  'otherVulnerability',
];
export type shortTermVulTypes = keyof Pick<
  Vulnerabilities,
  | 'bereavementVulnerability'
  | 'divorceVulnerability'
  | 'financialDifficultiesVulnerability'
  | 'inexperienceVulnerability'
  | 'otherEventVulnerability'
>;

export const shortTermVul: shortTermVulTypes[] = [
  'bereavementVulnerability',
  'divorceVulnerability',
  'financialDifficultiesVulnerability',
  'inexperienceVulnerability',
  'otherEventVulnerability',
];
